import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import * as firebase from "firebase/app";
import { AuthService } from "../../shared/services/auth.service";
import { Subscription } from "rxjs/Subscription";

@Component({
  selector: "app-location",
  templateUrl: "./location.component.html"
})
export class LocationComponent implements OnInit, OnDestroy {
  private authState: firebase.User | null;
  activeRouteIndex: number;
  type: string;
  routeSubscription: Subscription;
  components: any;

  constructor(private router: Router, private authService: AuthService, private route: ActivatedRoute) {
    this.authState = this.authService.getAuthState();
  }

  ngOnInit(): void {
    this.routeSubscription = this.route.params.subscribe(params => {
      this.activeRouteIndex = params.index;
      this.type = params.type || "country";
    });

    this.components = {
      country: false,
      state: false,
      city: false
    };

    if (Object.keys(this.components).includes(this.type)) {
      this.components[this.type] = true;
    } else {
      this.router.navigate([`basic/location/r/0`]);
    }
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }

  showComponent(component): void {
    const componentNames = Object.keys(this.components);
    componentNames.forEach(el => {
      this.components[el] = el === component ? true : false;
    });

    if (component !== "country") {
      this.router.navigate([`basic/location/${component}/r/0`]);
    } else {
      this.router.navigate([`basic/location/r/0`]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/basic/location/location.component.ts